import { useEffect, useRef } from "react";

// Production site key; override per environment with REACT_APP_TURNSTILE_SITE_KEY
// (e.g. Cloudflare's test key 1x00000000000000000000AA in .env.development.local).
const SITE_KEY =
  process.env.REACT_APP_TURNSTILE_SITE_KEY || "0x4AAAAAACzWgwOM6fZYfhb1";

export default function Turnstile({ onVerify, onExpire }) {
  const ref = useRef(null);
  const verifyRef = useRef(onVerify);
  const expireRef = useRef(onExpire);
  verifyRef.current = onVerify;
  expireRef.current = onExpire;

  useEffect(() => {
    let widgetId = null;
    let timer = null;
    let cancelled = false;

    // The Turnstile script loads async/defer, so it may not exist yet on mount.
    const tryRender = () => {
      if (cancelled) return;
      if (!window.turnstile || !ref.current) {
        timer = setTimeout(tryRender, 150);
        return;
      }
      widgetId = window.turnstile.render(ref.current, {
        sitekey: SITE_KEY,
        theme: "light",
        callback: (token) => verifyRef.current?.(token),
        "expired-callback": () => expireRef.current?.()
      });
    };

    tryRender();

    return () => {
      cancelled = true;
      clearTimeout(timer);
      if (widgetId !== null && window.turnstile) {
        window.turnstile.remove(widgetId);
      }
    };
  }, []);

  return <div ref={ref} />;
}
